import { Omit } from '@40seas/entities/common';
import { BaseEntityFieldsArray } from '@40seas/models';
import { CreditLineRequest } from './credit-line-request.entity';

export class CreateCreditLineRequestDto extends Omit(CreditLineRequest, [...BaseEntityFieldsArray, 'status']) {}
